import { Capacitor } from '@capacitor/core';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

function base64ToFile(base64String, filename) {
  const binary = atob(base64String);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: 'image/jpeg', lastModified: Date.now() });
}

/** Capture from device camera on native; returns null on web (use file picker). */
export async function captureInspectionPhoto() {
  if (!isNativeApp()) return null;

  const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera');
  const photo = await Camera.getPhoto({
    resultType: CameraResultType.Base64,
    source: CameraSource.Prompt,
    quality: 90,
    allowEditing: false,
    correctOrientation: true,
    width: 2048,
    saveToGallery: false,
  });

  if (!photo.base64String) {
    throw new Error('No photo captured');
  }

  return base64ToFile(photo.base64String, `inspection-${Date.now()}.jpg`);
}
